// category 分类 eg: 行业研究、公司动态、产品动态、社区动态、技术干货、客户案例、观点洞察、最佳实践
// desc 文章简要
// author 作者
// date 日期
// tags 标签 eg: ['FinOps','多云管理','私有云','融合云','Cloudpods','企业版','开源','新版本发布','混合云','Kubernetes','安全','备份与恢复','Golang','ARM']
// refer 是否为推荐文章
module.exports = {
  articleList: [
    {
      sortId: 151,
      id: '20260915',
      title: '私有云和多云管理平台 | Cloudpods v4.0.4 正式发布',
      category: '产品动态',
      desc: '本次版本以 AI 能力补齐为主：上线 AI 网关，推理从「实例」升级为可扩缩的「部署」，并支持 HAMI 显存共享与国产算力卡。同时新增 ModelScope 导入、SGLang 引擎、镜像 NFS 后端、IP 集以及 PVE 纳管重构等能力。',
      author: '李泽玺',
      date: '2026-09-15',
      tags: ['Cloudpods', '开源', '新版本发布'],
      refer: false,
    },
    {
      sortId: 150,
      id: '20260601',
      title: '私有云和多云管理平台 | Cloudpods v4.0.3 正式发布',
      category: '产品动态',
      desc: '本次版本更新主要是修复v4.0发布后遇到的兼容性问题，包括AI计算节点不兼容部分操作系统，不支持从旧版本kubernetes集群升级，QEMU 10.0.7的兼容性问题等。同时，也有不少重磅新功能的上线：AI云功能新上了Hermes Agent支持，vLLM推理引擎支持，支持直接挂载宿主机推理文件目录等；容器主机支持使用RBD磁盘；计费支持AWS，Azure预留实例的费用分摊（企业版）；监控支持将告警消息转为告警工单（企业版）。',
      author: '李泽玺',
      date: '2026-06-01',
      tags: ['Cloudpods', '开源', '新版本发布'],
      refer: false,
    },
    {
      sortId: 149,
      id: '20260408',
      title: '私有云和多云管理平台 | Cloudpods v4.0 正式发布',
      category: '产品动态',
      desc: '4.0 是一次大版本更新，最早 PR 可追溯到 2024 年春节前后，累计迭代近 2 年，共计 3695 个新增提交。围绕 AI 工作负载与国产替代两大趋势，4.x 重点增强 AI 工作负载支持、容器主机能力、更多异构 CPU 架构适配，以及全面 IPv6 支持。',
      author: '李泽玺',
      date: '2026-04-08',
      tags: ['Cloudpods', '开源', '新版本发布'],
      refer: true,
    },
    {
      sortId: 148,
      id: '20250807',
      title: '私有云和多云管理平台 | Cloudpods v3.11.11 正式发布',
      category: '产品动态',
      desc: '本次3.11.11更新亮点为：前端资源列表性能优化，大页数据分批次渲染，减少页面等待时间。改进lockman锁机制，提高高并发场景锁的稳定性。运行中内置虚拟化虚拟机添加网卡或变更IP地址时自动通过QGA配置网卡，实时生效。裸金属支持自动加入VLAN子网，实现基于VLAN的物理机网络隔离。赋予组织架构树状权限后用户查询速度优化，加速10倍以上（企业版）。',
      author: '李泽玺',
      date: '2025-08-07',
      tags: ['Cloudpods', '开源', '新版本发布'],
      refer: false,
    },
    {
      sortId: 147,
      id: '20250405',
      title: '私有云和多云管理平台 | Cloudpods v3.11.10 正式发布',
      category: '产品动态',
      desc: '本次3.11.10更新亮点为：对服务性能进行了系统性优化，包括虚拟机在资源较多情况下的调度时间，监控服务的查询时间，以及前端页面的渲染时间。监控面板和监控查询体验有较明显的改进，支持折叠监控面板，导出和排序监控数据，优化大量监控指标时的渲染速度等。安全全面升级，所有服务默认禁用TLS v1.0和1.1，禁用3DES，SHA1等存在缺陷的加密算法，关闭pprofiling接口，前端去除webpack源码映射信息等。内置虚拟化继续完善使用体验，如自动缓存磁盘镜像到 ceph 存储，提升ceph磁盘使用体验，本地磁盘克隆速率提升10倍以上等。',
      author: '李泽玺',
      date: '2025-04-05',
      tags: ['Cloudpods', '开源', '新版本发布'],
      refer: false,
    },
    {
      sortId: 146,
      id: '20241225',
      title: '私有云和多云管理平台 | Cloudpods v3.11.9 正式发布',
      category: '产品动态',
      desc: '本次3.11.9更新亮点为：对监控服务进行了功能优化，包括图表面板交互，添加了更多的宿主机指标，以及对结果聚合函数的排序等功能。对调度器并发创建虚拟机，短时间内重复计算资源的问题进行了修复，提升并发创建时调度的准确和可用性。创建虚拟机时，支持跨盘LVM逻辑卷的挂载识别和初始化。另外，之前版本部署集群时，会自动将dns_domain设置为一个我们认为不会使用的域名 cloud.onecloud.io 作为示例。但该域名自2024年10月31日开始接受解析，导致部分使用8.8.8.8域名解析服务且未修改dns_domain配置的用户开始遇到域名解析异常。因此自3.11.9开始，不再默认设置dns_domain。请遇到类似问题时关注此配置.',
      author: '李泽玺',
      date: '2024-12-25',
      tags: ['Cloudpods', '开源', '新版本发布'],
      refer: false,
    },
    {
      sortId: 145,
      id: '20241018',
      title: '私有云和多云管理平台 | Cloudpods v3.11.8 正式发布',
      category: '产品动态',
      desc: '本次3.11.8更新亮点为：ocboot 默认使用 k3s 作为运行平台服务的底座，替换旧的 v1.15.12 的 k8s 版本。新的部署方式将使用 buildah 和容器镜像的方式部署，更加干净和轻量，不需要在宿主机上安装 ansible 等 python 环境。同时 ocboot 也会兼容旧的 k8s 部署的集群，添加节点和升级服务都不受影响。部署虚拟机时自动部署QGA（qemu-guest-agent），依赖QGA的功能（如开机时修改主机密码，更换主机IP等）将更加可靠，后续还将基于QGA完善和扩展更多功能。前端对资源列表进行了整体性能优化，响应速度更快，体验更丝滑。',
      author: '李泽玺',
      date: '2024-10-18',
      tags: ['Cloudpods','开源','新版本发布'],
      refer: false,
    },
    {
      sortId: 144,
      id: '20240824',
      title: '私有云和多云管理平台 | Cloudpods v3.11.6 正式发布',
      category: '产品动态',
      desc: '本次3.11.6更新亮点为：改进了将纳管的VMware虚拟机一键迁移为Cloudpods KVM虚拟机，更加方便可靠；支持自动清理宿主机上的镜像缓存空间；修复operator对mysql 8.0用户sql的兼容问题。',
      author: '李泽玺',
      date: '2024-08-24',
      tags: ['Cloudpods','开源','新版本发布'],
      refer: false,
    },
    {
      sortId: 143,
      id: '20240705',
      title: '云联壹云 FinOps：赋能某车企公有云成本管理与精细化运营',
      category: '客户案例',
      desc: '云联壹云推出的 FinOps 解决方案，凭借其卓越的自动化、产品化与自服务优势，在协助某汽车制造企业有效驾驭公有云成本管理与深度分析过程中发挥了关键作用。',
      author: '高现起',
      date: '2024-07-05',
      tags: ['FinOps','多云管理','私有云'],
      refer: true,
    },
    {
      sortId: 142,
      id: '20240606',
      title: '私有云和多云管理平台 | Cloudpods v3.11.4 正式发布',
      category: '产品动态',
      desc: '本次 3.11.4 更新亮点为：系统镜像引入社区镜像，用户可以一键导入各主流开源操作系统镜像，方便用户上手使用。持续迭代共享 LVM ，支持快照，主备机等特性，修复迁移删除镜像缓存等 BUG 。',
      author: '宋登举',
      date: '2024-06-06',
      tags: ['Cloudpods','开源','新版本发布'],
      refer: false,
    },
    {
      sortId: 141,
      id: '20240523',
      title: '私有云和多云管理平台 | Cloudpods v3.10.15 正式发布',
      category: '产品动态',
      desc: '功能优化【主机】裸金属详情页增加部分属性信息 【监控】优化告警策略，支持同时设置多监控指标 【主机】支持透传设备自动探测 【主机】LVM 块存储支持快照 【监控】简化 Telegraf 容器的挂载点 【主机】新建 VMwa…',
      author: '宋登举',
      date: '2024-05-23',
      tags: ['Cloudpods','开源','新版本发布'],
      refer: false,
    },
    {
      sortId: 140,
      id: '20240428',
      title: '私有云和多云管理平台 | Cloudpods v3.11.3 正式发布',
      category: '产品动态',
      desc: '本次更新主要对 3.11 新引入特性进行了问题修复和功能优化，主要涉及主机 LVM 存储支持，IPv6 支持，userdata 等，同时对 FinOps 进行较多迭代，包括支持金山云账单，对接 Azure 对象存储账单，支持外部自定义数据…',
      author: '宋登举',
      date: '2024-04-28',
      tags: ['Cloudpods','开源','新版本发布'],
      refer: false,
    },
    {
      sortId: 139,
      id: '20240417',
      title: 'Flexera 2024 云状态报告解读',
      category: '行业研究',
      desc: '原文有很多章节，我节选了 10 个自认为对大家来说比较重要的一些结论或观点： 89% 的企业持续采用多云战略安全工具是大多数企业的首选，其次是成本优化（FinOps）工具和多云管理工具更多企业云成本同比增长 21%连…',
      author: '高现起',
      date: '2024-04-17',
      tags: ['FinOps','多云管理','私有云'],
      refer: true,
    },
    {
      sortId: 138,
      id: '20240412',
      title: '透视 Azure CPP 效益，云联壹云 FinOps 帮助某保险企业账单整合与 CPP 权益分配',
      category: '客户案例',
      desc: '背景某大型保险企业，客户在多云环境下运行超 2000 个资源实例，年度云服务支出逾千万。 面临跨公有云账单整合与 Azure CPP 权益精确管理难题，急需一体化成本管理和分析方案以提升效率并避免额外成本。 需求 1.Az…',
      author: '高现起',
      date: '2024-04-12',
      tags: ['FinOps','多云管理','企业版'],
      refer: true,
    },
    {
      sortId: 137,
      id: '20240401',
      title: '私有云和多云管理平台 | Cloudpods v3.11.2 正式发布',
      category: '产品动态',
      desc: '功能优化【报表】支持忽略费用为 0 的项目清单（企业版）【网络】支持同步负载均衡安全组信息【网络】支持同步华为云公网 NAT 网关【多云】支持对接 Azure 国际存储桶账单【主机】支持通过 WebConsole 文件上传和…',
      author: '高现起',
      date: '2024-04-01',
      tags: ['Cloudpods','开源','新版本发布'],
      refer: false,
    },
    {
      sortId: 136,
      id: '20240321',
      title: '云联壹云助力某国际知名连锁餐饮企业实现 FinOps 卓越运营',
      category: '客户案例',
      desc: '背景自上世纪 90 年代进入中国，客户持续致力于为广大消费者提供高品质的快餐体验。如今，中国已成为其全球第二大市场，每年服务顾客数量超过 10 亿，拥有近几千家餐厅和超过 20 万员工。随着业务规模的不断扩大，…',
      author: '高现起',
      date: '2024-03-21',
      tags: ['FinOps','多云管理','企业版'],
      refer: true,
    },
    {
      sortId: 135,
      id: '20240320',
      title: '云联壹云加入 OpenCloudOS 社区，完成技术兼容互认证',
      category: '产品动态',
      desc: '近日，云联壹云正式加入 OpenCloudOS 操作系统开源社区，并完成了云联壹云融合云平台与 OpenCloudOS 的相互兼容认证，测试期间，整体运行稳定，在功能、性能及兼容性方面表现良好。 一、公司与产品简介作为「产品…',
      author: '高现起',
      date: '2024-03-20',
      tags: ['私有云','融合云','Cloudpods','企业版','开源'],
      refer: false,
    },
    {
      sortId: 134,
      id: '20240312',
      title: '私有云和多云管理平台 | Cloudpods v3.10.13 正式发布',
      category: '产品动态',
      desc: '功能优化【主机】支持 PVE 平台主机 VNC 连接【容器】支持租户视图新建 k8s 集群【主机】KVM 支持 OpenCloudOS/OpenKylin/AlmaLinux/UOSDesktop 操作系统【调度】优化对于不同主机类型的调度性能【主机】ISO 创建…',
      author: '高现起',
      date: '2024-03-12',
      tags: ['Cloudpods','开源','新版本发布'],
      refer: false,
    },
    {
      sortId: 133,
      id: '20240228',
      title: '私有云和多云管理平台 | Cloudpods v3.11.0 正式发布',
      category: '产品动态',
      desc: 'v3.11 重点功能介绍版本 3.11 自 2023 年 4 月开始开发，历时大概 10 个月，共计 4000 多个PR。 1.开源之夏 2023感谢开源之夏 2023 的四位同学为 Cloudpods v3.11 贡献如下功能： 虚拟机紧急模式：允许将虚拟机引…',
      author: '高现起',
      date: '2024-02-28',
      tags: ['Cloudpods','开源','新版本发布'],
      refer: true,
    },
    {
      sortId: 132,
      id: '20240131',
      title: '私有云和多云管理平台 | Cloudpods v3.10.12 正式发布',
      category: '产品动态',
      desc: '开源社区: Cloudpods.orgGitHub： https://github.com/yunionio/cloudpods功能优化【多云】优化 HCS 及 HCSOP 账号录入模式（企业版） 【主机】优化物理机注册输入方式，MAC 地址修改为非必填 【调度】减少从数据…',
      author: '宋登举',
      date: '2024-01-31',
      tags: ['Cloudpods','开源','新版本发布'],
      refer: false,
    },
    {
      sortId: 131,
      id: '20240102',
      title: '私有云和多云管理平台 | Cloudpods v3.10.10 正式发布',
      category: '产品动态',
      desc: '开源社区: Cloudpods.orgGitHub： https://github.com/yunionio/cloudpods概述本次发布为 3.10 在 2023 年的最后一个小版本发布（因测试原因跳过 3.10.9 版本），主要完善自 3.10.8 发布后集中反馈的轻量虚拟机部…',
      author: '邱剑',
      date: '2024-01-02',
      tags: ['Cloudpods','开源','新版本发布'],
      refer: false,
    },
    {
      sortId: 130,
      id: '20231211',
      title: '私有云和多云管理平台 | Cloudpods v3.10.8 正式发布',
      category: '产品动态',
      desc: '开源社区： https://www.cloudpods.org/zh/GitHub： https://github.com/yunionio/cloudpods总结本次发布为 v3.10 以来最重要小版本发布，包含三项重大更新： 一、虚拟机部署方式改为采用轻量虚拟机模式。本地私有…',
      author: '宋登举',
      date: '2023-12-11',
      tags: ['Cloudpods','开源','新版本发布'],
      refer: false,
    },
    {
      sortId: 129,
      id: '20231110',
      title: '私有云和多云管理平台 | Cloudpods v3.10.7 发布',
      category: '产品动态',
      desc: ' 开源社区： https://www.cloudpods.org/zh/GitHub： https://github.com/yunionio/cloudpodsCloudpods v3.10.7本次发布重点是对已有功能的优化和修复，例如对接了天翼云新版本 API，相比较之前对接的 v1 版本接口…',
      author: '宋登举',
      date: '2023-11-10',
      tags: ['Cloudpods','开源','新版本发布'],
      refer: false,
    },
    {
      sortId: 128,
      id: '20231013',
      title: '新版发布 | Cloudpods v3.10.6 和 v3.9.14 正式发布',
      category: '产品动态',
      desc: 'Cloudpods v3.10.6本期发布中，前端优化了静态资源的加载机制，将页面打开前需加载的静态资源包从 80 MB 缩减为 2 MB，首页加载速度有明显提升。另外值得一提的是开源之夏 @chentianxiang 同学的 #【 17600 通过 Q…',
      author: '邱剑',
      date: '2023-10-13',
      tags: ['Cloudpods','开源','新版本发布'],
      refer: false,
    },
    {
      sortId: 127,
      id: '20230915',
      title: '新版发布 | Cloudpods v3.10.5 和 v3.9.13 正式发布',
      category: '产品动态',
      desc: 'Cloudpods v3.10.5本期发布中，ocboot 部署脚本有较多变化，首先支持以非 root 用户执行安装流程，其次响应社区的呼吁，增加了--stack 参数，允许 Allinone 一键安装仅包含私有云（参数为 edge）或云管（参数为 cm…',
      author: '宋登举',
      date: '2023-09-15',
      tags: ['Cloudpods','开源','新版本发布'],
      refer: false,
    },
    {
      sortId: 126,
      id: '20230825',
      title: 'Cloudpods 私有云平台有哪些优势？',
      category: '行业研究',
      desc: '作为一套完整的私有云管理软件，我们经常会被问到 Cloudpods 和其他的同类产品相比，有哪些优势？我总结了 2 个方面，供大家参考。 功能方面 产品化，开箱即用，易用性较高，基本上都可以傻瓜式的操作，当然有些牵…',
      author: '高现起',
      date: '2023-08-25',
      tags: ['私有云','Cloudpods','开源'],
      refer: true,
    },
    {
      sortId: 125,
      id: '20230818',
      title: '新研究：Gartner 公有云成本管理框架',
      category: '行业研究',
      desc: '整理：高现起 2023年6月28日，Gartner 出版了名为《Beyond FinOps: the Gartner Framework for Public Cloud Financial Management》的公有云成本管理框架，旨在帮助企业/组织应对公有云支出的挑战，同时抓住新机…',
      author: '高现起',
      date: '2023-08-18',
      tags: ['FinOps','企业版'],
      refer: true,
    },
    {
      sortId: 124,
      id: '20230811',
      title: 'FinOps 应用入门指南',
      category: '行业研究',
      desc: '整理：高现起 入门指南介绍什么是 FinOps ？FinOps 是一种云成本管理和优化的解决方案，并为组织、企业、团队提供了系统化的方法论，其中每个人都应该对自己的云资源成本负责。 FinOps 是“Finance”和“DevOps”…',
      author: '高现起',
      date: '2023-08-11',
      tags: ['FinOps','企业版'],
      refer: true,
    },
    {
      sortId: 123,
      id: '20230804',
      title: '新版发布 | Cloudpods v3.10.4 和 v3.9.12 正式发布',
      category: '产品动态',
      desc: 'Cloudpods v3.10.4功能优化【主机】支持 PVE 资源的生命周期管理 【费用】优化阿里云账单资源类型名称（企业版） 【主机】选择 VMware 平台镜像，磁盘支持容量变更 【主机】在线修改密码需先探测 QGA 状态 【主机…',
      author: '宋登举',
      date: '2023-08-04',
      tags: ['Cloudpods','开源','新版本发布'],
      refer: false,
    },
    {
      sortId: 122,
      id: '20230728',
      title: '【客户案例】云联壹云助力某保险公司搭建公有云费用管理平台',
      category: '客户案例',
      desc: '客户介绍客户成立于 1996 年 11 月，现已拥有逾 2000 名员工和 12000 名营销员，为 280 万客户提供专业的金融保险服务。在上海、北京、广东、浙江、江苏、四川、山东、福建、重庆、辽宁、天津、湖北、河北、湖南和…',
      author: '宋登举',
      date: '2023-07-28',
      tags: ['FinOps','企业版'],
      refer: false,
    },
    {
      sortId: 121,
      id: 'UDLR6PeP',
      title: '喜讯！云联壹云入选2023年北京市“专精特新”中小企业',
      category: '公司动态',
      desc: '6月25日，北京市经济和信息化局发布《关于对2023年第一季度北京市专精特新中小企业名单进行公告的通知》，北京云联壹云技术有限公司入选2023年北京市“专精特新”中小企业。 “专精特新”是国家为增强企业自主创新…',
      author: '高现起',
      date: '2023-07-07',
      tags: ['FinOps','多云管理','私有云'],
      refer: false,
    },
    {
      sortId: 120,
      id: '20230707',
      title: '新版发布 | Cloudpods v3.10.3 和 v3.9.11 正式发布',
      category: '产品动态',
      desc: 'Cloudpods v3.10.3新功能【认证】支持用户在个人中心查看消息订阅 【容器】Helm release 实例前端支持升级与回滚 【关于】增加平台升级记录（企业版） 【巡检】巡检报告支持下载（企业版） 功能优化【主机】ssh 登…',
      author: '卢向杰',
      date: '2023-07-07',
      tags: ['Cloudpods','开源','新版本发布'],
      refer: false,
    },
    {
      sortId: 119,
      id: '20230628',
      title: '关于云成本管理和优化 FinOps，你需要知道的一切',
      category: '行业研究',
      desc: 'FinOps 是什么？FinOps 是一种云成本管理和优化的解决方案，并为组织、企业、团队提供了系统化的方法论，其中每个人都应该对自己的云资源成本负责。 FinOps 是“Finance”和“DevOps”的合成词，强调…',
      author: '高现起',
      date: '2023-06-28',
      tags: ['FinOps','企业版'],
      refer: true,
    },
    {
      sortId: 118,
      id: '20230616',
      title: '云联壹云企业版新增自动巡检功能',
      category: '产品动态',
      desc: '我们在 v3.10 的企业版中新增了自动巡检功能，关于设计这个功能的初衷以及效果、客户收益简单给大家介绍一下。 自动巡检功能介绍该服务具备以下三个方面的监控和检查： 服务器监控状态：检查服务器 CPU/内存/磁盘…',
      author: '卢向杰',
      date: '2023-06-16',
      tags: ['企业版'],
      refer: false,
    },
    {
      sortId: 117,
      id: '20230609',
      title: '【客户案例】云联壹云帮助华北电力大学搭建 AI 训练平台',
      category: '客户案例',
      desc: '客户介绍华北电力大学是教育部直属全国重点大学，是国家“211 工程”和“985 工程优势学科创新平台”重点建设大学。2017 年，学校进入国家“双一流”建设高校行列，重点建设能源电力科学与工程学科群，全面开启了…',
      author: '高现起',
      date: '2023-06-09',
      tags: ['私有云'],
      refer: false,
    },
    {
      sortId: 116,
      id: '20230602',
      title: '新版发布 | Cloudpods v3.10.2 正式发布',
      category: '产品动态',
      desc: '作者：宋登举 距离 v3.10 大版本发布刚过去一个月， v3.10.2 也要正式 release 了，快来看看它新增了哪些新功能以及修复了哪些问题吧。 新功能【认证】品高云 OAuth 认证源支持 【主机】支持自定义 PCI 透传设备的…',
      author: '宋登举',
      date: '2023-06-02',
      tags: ['Cloudpods','新版本发布','企业版'],
      refer: false,
    },
    {
      sortId: 115,
      id: '20230524',
      title: 'Bash 代码优化思考',
      category: '技术干货',
      desc: '最近我在思考这样一个问题，顺便看一下gpt对这个问题的解释。搜索发现： 团队写代码，为什么要遵循coding guideline？一致性：编码准则确保整个团队的代码风格和格式是一致的，这使得团队成员之间更易于交流和协作。',
      author: '云联壹云',
      date: '2023-05-24',
      tags: ['开源'],
      refer: false,
    },
    {
      sortId: 114,
      id: '20230517',
      title: '云联壹云融合云管理平台的 10 大应用场景',
      category: '客户案例',
      desc: '随着融合云管理平台功能越来越多，不同客户使用到的功能区别很大，最近梳理了一下现有的在网客户使用情况，总结了 10 大应用场景，供大家参考。',
      author: '高现起',
      date: '2023-05-17',
      tags: ['企业版','Cloudpods','私有云','多云管理','FinOps'],
      refer: true,
    },
    {
      sortId: 113,
      id: '20230515',
      title: 'SkyPilot：构建在多云之上的 ML 和数据科学，可节约 3 倍以上成本',
      category: '行业研究',
      desc: '用于 ML 和数据科学的云计算已经比较困难，如果你想要通过成本优化削减成本，你的整体成本包括资源和人力，可能会不降反增。不想在机器闲置时停止？因为这样你可能需要反复的启停，并且重新配置环境或者准备数据。想要通过使用抢占实例降低成本？解决抢占实例的调度问题也可能会花上几周时间。如何很好的利用地区之间的巨大价格差异，或者不同云厂商之间更大的价格差异来降低成本？',
      author: '高现起',
      date: '2023-05-15',
      tags: ['多云管理','FinOps','开源'],
      refer: true,
    },
    {
      sortId: 112,
      id: '20230506',
      title: 'Flexera 2023 云状态报告解读',
      category: '行业研究',
      desc: '根据 Flexera 2023 云状态报告显示，经济问题不会减缓公有云市场的增长；FinOps 仍然处于应用多云战略的企业首要关注的问题；AWS 和 Azure 在全球市场仍处于领导地位。',
      author: '高现起',
      date: '2023-05-06',
      tags: ['FinOps','多云管理','私有云'],
      refer: true,
    },
    {
      sortId: 111,
      id: 'mU2wOJHf',
      title: '新品发布 | Cloudpods 3.10版本上线！',
      category: '产品动态',
      desc: 'Cloudpods 是一个开源的 Golang 实现的云原生的多云和混合云融合平台。Cloudpods 不仅可以管理本地的虚拟机和物理机资源，还可以管理其他公有云和私有云平台的资源。',
      author: '宋登举',
      date: '2023-05-06',
      tags: ['Cloudpods','新版本发布','企业版'],
      refer: true,
    },
    {
      sortId: 110,
      id: 'iSx1veld',
      title: '企业面对FinOps，到底能做些什么？总结了4个方面',
      category: '最佳实践',
      desc: '之前花时间研究了一下云成本管理和优化，算是有一些收获，我今天把这些分享出来，算是抛砖引玉了，如果有朋友有更好的方法或者好的文章，也欢迎推荐给我们。',
      author: '高现起',
      date: '2023-05-06',
      tags: ['FinOps'],
      refer: true,
    },
    {
      sortId: 109,
      id: '9fPo5mTS',
      title: '新品发布 | Cloudpods 3.9.8 版本上线！',
      category: '产品动态',
      desc: '3月17日，Cloudpods 新版本 v3.9.8 正式发布。本次更新主要支持虚拟机整机更换块存储及其他一些修复优化。',
      author: '云联壹云',
      date: '2023-05-06',
      tags: ['Cloudpods','新版本发布','企业版'],
      refer: false,
    },
    {
      sortId: 108,
      id: 'sTCoKaWw',
      title: '推荐一个开源虚拟化及云管管理平台',
      category: '最佳实践',
      desc: '将几台物理服务器虚拟化成一个私有云平台 需要一个紧凑而且功能相对完整的物理机全生命周期管理工具 将 VMware vSphere 虚拟化集群转换为一个可以自服务的私有云平台 存在使用多云场景，能够在一个界面管理私有云和公有云资源。',
      author: '云联壹云',
      date: '2023-05-06',
      tags: ['Cloudpods','开源','私有云','多云管理'],
      refer: false,
    },
    {
      sortId: 107,
      id: 'ZcBcPi2D',
      title: '开源的虚拟化私有云及云管平台',
      category: '最佳实践',
      desc: '免费开源的私有云及云管平台来了，除虚拟化外，还支持纳管主流的 9 大公有云及私有云平台，欢迎大家安装体验！',
      author: '云联壹云',
      date: '2023-05-01',
      tags: ['Cloudpods','开源','私有云','多云管理'],
      refer: false,
    },
    {
      sortId: 106,
      id: 'YPR8B4o6',
      title: '新品发布 | Cloudpods 3.9.6 版本上线！',
      category: '产品动态',
      desc: '1月6日，Cloudpods 新版本 v3.9.6 正式发布。本次更新主要是以优化为主，如主备机切换优化、主机升级CentOS ARM内核版本到5.4.199等。',
      author: '云联壹云',
      date: '2023-05-01',
      tags: ['企业版','新版本发布','Cloudpods'],
      refer: false,
    },
    {
      sortId: 105,
      id: 'E8uBIubj',
      title: '新品发布 | Cloudpods 3.9.5 版本上线！',
      category: '产品动态',
      desc: '12月8日，Cloudpods 新版本 v3.9.5 正式发布。本次更新主要是允许纳管没有BMC的物理机、支持通过快照创建磁盘及其他一些修复优化。',
      author: '云联壹云',
      date: '2023-05-01',
      tags: ['企业版','新版本发布','Cloudpods'],
      refer: false,
    },
    {
      sortId: 104,
      id: 'Pxby2VcQ',
      title: '选择混合云还是多云？企业要考虑这些因素！',
      category: '观点洞察',
      desc: '有时，单个公共云服务并不能解决问题。在某些用例中，多云和混合可能更适合企业发展。为了解决安全性和合规性等挑战，企业通常将云计算引入内部，并结合其公共云资源采用私有云模型。这称为混合云。其他公司通过采用多云方法来扩展其公共云功能。据Flexera称，大约 93% 的企业已经制定了多云战略，平均使用四种云服务。',
      author: '云联壹云',
      date: '2023-05-01',
      tags: ['多云管理','混合云'],
      refer: false,
    },
    {
      sortId: 103,
      id: 'aqLqNJic',
      title: '详解“开放云”的真正含义！',
      category: '行业研究',
      desc: '当应用到云端时，开放究竟意味着什么？在现代软件工程世界中，有一种将“开放性”置于一切之上的趋势，好像开源中的“开放性”可以很容易地应用于工程堆栈的其他部分',
      author: '云联壹云',
      date: '2023-05-01',
      tags: ['多云管理','混合云'],
      refer: false,
    },
    {
      sortId: 102,
      id: 'y0ZVqpGm',
      title: '私有云与公共云：Kubernetes 如何改变平衡？',
      category: '行业研究',
      desc: '当今企业大部分都会成为混合云用户。2021 年 Statista 对 750 家企业的调查发现，82% 的企业采用了混合云计算战略。',
      author: '云联壹云',
      date: '2023-05-01',
      tags: ['私有云','混合云','Kubernetes'],
      refer: false,
    },
    {
      sortId: 101,
      id: '2BCcm1Ws',
      title: '新品发布 | Cloudpods 3.9.1 版本上线！',
      category: '产品动态',
      desc: '历经近10个月的研发打磨，3.9版本终于发布了。主要更新如下： 费用管理 3.9版本在费用方面有较多的更新。最值得一提的是3.9开始正式采用Clickhouse作为费用数据的存储。',
      author: '云联壹云',
      date: '2023-05-01',
      tags: ['企业版','新版本发布','Cloudpods'],
      refer: false,
    },
    {
      sortId: 100,
      id: 'EWxSaTUz',
      title: '版本特性 | Cloudpods v3.9重点功能介绍',
      category: '产品动态',
      desc: '3.9 版本已经有一段时间了，我们汇总了 3.9 版本的重点功能进行介绍，希望能帮助用户更高效的使用云联壹云产品完成相应工作，3.9 版本在计费方面有较大的更新，如计费服务账单存储引擎升级及多维度分析优化，在组织架构方面支持了多层级的组织架构及权限，在多云管理方面，支持同步云账号时仅同步部分资源，可以更快的同步更新所需资源。',
      author: '云联壹云',
      date: '2023-05-01',
      tags: ['企业版','新版本发布','Cloudpods'],
      refer: false,
    },
    {
      sortId: 99,
      id: 'W1OeBavT',
      title: '新品发布 | Cloudpods 3.9.2 版本上线！',
      category: '产品动态',
      desc: '9月14日，Cloudpods 新版本 v3.9.2 正式发布。本次更新主要支持纳管高版本k8s及其他一些修复优化。',
      author: '云联壹云',
      date: '2023-05-01',
      tags: ['企业版','新版本发布','Cloudpods'],
      refer: false,
    },
    {
      sortId: 98,
      id: 'Zp30JKgU',
      title: '新品发布 | Cloudpods 3.9.4 版本上线！',
      category: '产品动态',
      desc: '10月31日，Cloudpods 新版本 v3.9.4 正式发布。本次更新主要是KVM平台主机对接QGA、新建主机同时安装监控Agent及其他一些修复优化',
      author: '云联壹云',
      date: '2023-05-01',
      tags: ['企业版','新版本发布','Cloudpods'],
      refer: false,
    },
    {
      sortId: 97,
      id: '3PaIfsyQ',
      title: 'Cloudpods容器化经验分享',
      category: '技术干货',
      desc: 'Cloudpods从3.0开始全面拥抱Kubernetes，基于Kubernetes部署运行云平台的服务组件，采用Kubernetes Operator，基于Kubernetes集群自动化部署服务，实现了云平台的服务的容器化分布式部署。本文总结了Cloudpods在过去3年云平台底层容器化改造的经验。',
      author: '云联壹云',
      date: '2023-05-01',
      tags: ['Kubernetes','Cloudpods'],
      refer: false,
    },
    {
      sortId: 96,
      id: 'GX85jKxB',
      title: '2022正在发生的16项云创新趋势！',
      category: '观点洞察',
      desc: '在现收现付定价模式的背后，公有云中有最新最好的开发、devops 和 AI 工具，用于更快地构建更好、更智能的应用程序。',
      author: '云联壹云',
      date: '2023-05-01',
      tags: ['混合云'],
      refer: false,
    },
    {
      sortId: 95,
      id: 'K8xURB09',
      title: '2022 年 8 种云计算趋势：超支、安全和工作负载',
      category: '观点洞察',
      desc: '从平均在公共云上花费 120 万美元到 600 万美元的企业，到中小型企业在 2022 年将工作负载置于何处，下面为大家介绍八大云计算趋势。',
      author: '云联壹云',
      date: '2023-05-01',
      tags: ['混合云','私有云','FinOps'],
      refer: false,
    },
    {
      sortId: 94,
      id: 'dZ7rRmPl',
      title: '企业采用云的必备之选：10 步云迁移清单',
      category: '最佳实践',
      desc: '由于云计算行业的飞速发展，现在很多企业都致力于将关键企业应用程序迁移到公共云。在某些情况下，企业团队在云迁移中遇到了困难，并且成果有限。但可以通过所学到的经验教训在随后的尝试中改进结果。',
      author: '云联壹云',
      date: '2023-05-01',
      tags: ['多云管理'],
      refer: false,
    },
    {
      sortId: 93,
      id: 'hJCfXWVe',
      title: '企业应如何制定多云世界的反脆弱身份？',
      category: '观点洞察',
      desc: 'Nassim Taleb 曾在《黑天鹅》一书中描述了随机且不频繁发生的改变游戏规则的事件，同时提出了一个理论，即如何提高系统的健壮性，并使它们能够在意外发生时承受冲击。书中描述的是银行系统，但同样的概念也适用于技术。',
      author: '云联壹云',
      date: '2023-05-01',
      tags: ['多云管理'],
      refer: false,
    },
    {
      sortId: 92,
      id: 'NherkGWf',
      title: '为什么云优先流程集成最适合云应用程序？',
      category: '观点洞察',
      desc: '随着企业在数字技术上的支出持续增长，疫情加速了数字和云的采用。根据 UnivDatos Market Insights 的一份报告，预计 2021-2026 年全球数字化转型市场将以 16.1% 的复合年增长率增长，到 2026 年将高达 36938 亿美元。',
      author: '云联壹云',
      date: '2023-05-01',
      tags: ['多云管理'],
      refer: false,
    },
    {
      sortId: 91,
      id: '0JDvRtBY',
      title: '详解用于混合和多云的共享 Kubernetes 集群',
      category: '最佳实践',
      desc: '现在，混合云和多云部署比以往更符合企业的关键需求。随着企业中 Kubernetes 采用的增长，有效管理多集群部署对于应用程序交付变得越来越重要。为了将 Kubernetes 的使用和混合/多云基础架构结合在一起，IT 组织需要一个现代操作模型，用于混合和多云架构中的共享 K8s 集群。',
      author: '云联壹云',
      date: '2023-05-01',
      tags: ['混合云','多云管理','Kubernetes'],
      refer: false,
    },
    {
      sortId: 90,
      id: 'gZuaiNdV',
      title: '企业部署到云的 API 驱动应用程序应注意这些安全事项',
      category: '观点洞察',
      desc: '在过去几年中，API 驱动的应用程序在企业级云平台上部署以扩展规模兴起。它们能够根据用户需求进行扩展，彻底改变了应用程序的编写和部署方式。通常，这些分布式应用程序部署在 Kubernetes 平台上，以便更轻松地管理、编排和部署微服务容器。',
      author: '云联壹云',
      date: '2023-05-01',
      tags: ['多云管理','安全'],
      refer: false,
    },
    {
      sortId: 89,
      id: 'TOYclKX7',
      title: '将数据迁移到云端时，什么对于企业而言最重要？',
      category: '观点洞察',
      desc: '如果有一个几乎每个 IT 领导者都害怕的操作，那一定是数据库迁移。CIO 经常采用回避策略。数据库迁移通常会传递给下一个技术团队，而不是试图解决它。',
      author: '云联壹云',
      date: '2023-05-01',
      tags: ['多云管理'],
      refer: false,
    },
    {
      sortId: 88,
      id: 'yzrM4rgX',
      title: '企业真的准备好使用多云了吗？',
      category: '观点洞察',
      desc: '对于许多企业而言，使用多个公有云是不可避免的。以下是如何使多云具有战略性而不是偶然性。',
      author: '云联壹云',
      date: '2023-05-01',
      tags: ['多云管理'],
      refer: false,
    },
    {
      sortId: 87,
      id: 'LQpb5WFk',
      title: '企业多云管理：在技术、人员、流程方面面临的挑战',
      category: '观点洞察',
      desc: '在管理混合云和多云环境时，有很多选择，但没有捷径可走，也会面临一些挑战。',
      author: '云联壹云',
      date: '2023-05-01',
      tags: ['多云管理'],
      refer: false,
    },
    {
      sortId: 86,
      id: 'wCWCQrfX',
      title: '企业在混合云中管理数据的4个最佳实践',
      category: '最佳实践',
      desc: '当企业的数据位于单个数据中心或云中时，数据管理会变得十分困难。当企业选择混合云策略时，在跟踪、保护和管理数据方面，将面临全新的复杂性。',
      author: '云联壹云',
      date: '2023-05-01',
      tags: ['混合云','多云管理'],
      refer: false,
    },
    {
      sortId: 85,
      id: '7DHjm5od',
      title: '2022 — Kubernetes的发展爆发之年',
      category: '行业研究',
      desc: '虽然Kubernetes仍然是一项相对年轻的技术，但已迅速被世界各地的IT组织采用。Gartner曾预测，到2022年，一半的企业核心服务将在容器编排环境中运行。',
      author: '云联壹云',
      date: '2023-05-01',
      tags: ['Kubernetes'],
      refer: false,
    },
    {
      sortId: 84,
      id: '4NisHtwh',
      title: '混合云、多云的兴起对云环境意味着什么？',
      category: '观点洞察',
      desc: '由于全球疫情大流行，灵活性对企业来说变得至关重要——在业务运营中比以往任何时候都更加普遍。绝大多数公司都制定了灵活的工作政策来留住和吸引员工；在幕后，他们也越来越多地采用云服务，以在不确定的时期实现敏捷性。',
      author: '云联壹云',
      date: '2023-05-01',
      tags: ['混合云','多云管理'],
      refer: false,
    },
    {
      sortId: 83,
      id: 'OE6llBMs',
      title: '企业如何选择最佳云服务提供商？',
      category: '最佳实践',
      desc: '当前的企业依靠云服务来增强其运营中的基础设施（网络、存储、数据库）、服务或软件。该基础架构支持性能、灵活性、创新、可扩展性并降低成本。',
      author: '云联壹云',
      date: '2023-05-01',
      tags: ['多云管理'],
      refer: false,
    },
    {
      sortId: 82,
      id: 'AvvaGPOP',
      title: '多云VS天空计算，企业应如何选择云计算战略？',
      category: '观点洞察',
      desc: '在多云和天空计算之间进行选择时，企业管理者必须首先了解选择的成本和收益。',
      author: '云联壹云',
      date: '2023-05-01',
      tags: ['混合云','多云管理'],
      refer: false,
    },
    {
      sortId: 81,
      id: '4F5Vfia7',
      title: '企业降低云成本的13个有力措施！',
      category: '最佳实践',
      desc: '云计算的出现，最开始是一个经济命题。服务器很昂贵，所需的空间和服务器发展所需的大量互联网连接也很昂贵。为什么不直接租用它们并停止支付大笔硬件费用，减少维护它的员工呢？大型云数据中心可以节省大量资金，然后将节省的资金分散给各位使用者。',
      author: '云联壹云',
      date: '2023-05-01',
      tags: ['FinOps','多云管理','混合云'],
      refer: false,
    },
    {
      sortId: 80,
      id: 'h73Mkiyl',
      title: '企业迁移到云之前要考虑的关键因素',
      category: '观点洞察',
      desc: '云计算是指通过互联网按需使用服务器、数据存储、数据库、网络等开发工具。云计算使企业能够更快地启动和运行他们的应用程序。通过更少的维护和改进的可管理性，它允许团队快速调整以满足不断变化的资源需求。',
      author: '云联壹云',
      date: '2023-05-01',
      tags: ['FinOps','多云管理','混合云'],
      refer: false,
    },
    {
      sortId: 79,
      id: 'xwWVPF3G',
      title: '云计算 3.0 的发展面临哪三大挑战？',
      category: '行业研究',
      desc: '云计算1.0专注于基于虚拟化的基础架构即服务 (IaaS)。云计算 2.0 引入了云原生服务，例如大数据、AI/ML、可扩展的中间件服务以及基于容器化等概念的开发。',
      author: '云联壹云',
      date: '2023-05-01',
      tags: ['FinOps','多云管理','混合云'],
      refer: false,
    },
    {
      sortId: 78,
      id: 'EiFPPOjd',
      title: '人工智能将如何改进云计算？',
      category: '观点洞察',
      desc: '如今，人工智能与云计算相结合，可以帮助企业管理数据、发现信息模式、提供更好的客户体验并简化工作流程。人工智能技术和云计算已经开始连接智能机器并管理它们生成的大量数据。人工智能 (AI) 和机器学习这两种显著提高云安全自动化的技术，是企业现在正在探索的路径。',
      author: '云联壹云',
      date: '2023-05-01',
      tags: ['FinOps','多云管理','混合云'],
      refer: false,
    },
    {
      sortId: 77,
      id: 'Ht5gIxYV',
      title: '云迁移和管理成本偏离轨道的不同方式及管理措施',
      category: '观点洞察',
      desc: '云计算提供了改变公司开展业务方式的机会。云采用可以帮助企业降低成本、变得更加敏捷、更快地开发新功能，并为企业的客户提供可靠的、全球可用的服务。',
      author: '云联壹云',
      date: '2023-05-01',
      tags: ['FinOps','多云管理','混合云'],
      refer: false,
    },
    {
      sortId: 76,
      id: 'xGwbaFoX',
      title: '2022 年云计算发展趋势',
      category: '观点洞察',
      desc: '从疫情到国际供应链问题，全球商业环境最近发生了很多变化，我们的工作和生活方式可能永远不能回到从前。因此，云计算技术的接受和使用速度显著加快——电子商务和远程工作作为两种文化变化已经变得越来越普遍。',
      author: '云联壹云',
      date: '2023-05-01',
      tags: ['FinOps','多云管理','混合云'],
      refer: false,
    },
    {
      sortId: 75,
      id: 'RgAz5qbX',
      title: '企业应如何解决云成本优化悖论？',
      category: '观点洞察',
      desc: '最近一篇题为“云的成本，万亿美元悖论”的分析备受关注。这篇文章挑战了围绕云转型和云迁移狂热的传统思维，它要求我们思考云基础设施成本的影响（以及这反过来对公司估值的影响）。',
      author: '云联壹云',
      date: '2023-05-01',
      tags: ['FinOps','多云管理'],
      refer: false,
    },
    {
      sortId: 74,
      id: 'sPtMLpOb',
      title: '详解云计算和开源时代的锁定',
      category: '观点洞察',
      desc: '在云计算领域，我们经常就锁定问题进行讨论。什么是供应商锁定？还有其他类型的锁定吗？云可以保护您免受锁定吗？开源解决方案可以创建锁定吗？',
      author: '云联壹云',
      date: '2023-05-01',
      tags: ['多云管理','开源'],
      refer: false,
    },
    {
      sortId: 73,
      id: 'goEjS8Jr',
      title: '企业完成云转型的成功之道：云成本优化管理',
      category: '观点洞察',
      desc: '近年来，各行各业的企业的云采用率迅速增加，预计向云的迁移将继续加速，以实现快速的敏捷性以及以最少的资本支出获得规模和弹性。即用即付定价带来的成本优势也是推动云采用的关键驱动因素之一。',
      author: '云联壹云',
      date: '2023-05-01',
      tags: ['多云管理','FinOps'],
      refer: false,
    },
    {
      sortId: 72,
      id: 'ICBkShuy',
      title: '企业在2022 年应避免这 6 大云成本优化问题',
      category: '观点洞察',
      desc: '在企业发展过程中，全球大量工程团队会将时间和精力投入到云优化上，但研究表明大多数企业无法跟上飙升的云成本。',
      author: '云联壹云',
      date: '2023-05-01',
      tags: ['多云管理','FinOps'],
      refer: false,
    },
    {
      sortId: 71,
      id: '9Efdf07Z',
      title: '云管理平台成功要素——强大的自动化集成',
      category: '观点洞察',
      desc: '自动化对于有效的基础设施管理至关重要。当 IT 团队必须管理数百甚至数千个应用程序和服务器时，手动操作不仅效率低下，而且难以完成。',
      author: '云联壹云',
      date: '2023-05-01',
      tags: ['多云管理'],
      refer: false,
    },
    {
      sortId: 70,
      id: 'exrwNoY8',
      title: '在企业中采用多云战略的最佳实践',
      category: '最佳实践',
      desc: '当今的企业正站在云革命的起点。向混合/多云架构的转变使企业能够选择多个云服务提供商，为开发人员提供最佳工具来创建引人注目的用例。它还消除了由单点故障、依赖性和供应商锁定引起的风险。',
      author: '云联壹云',
      date: '2023-05-01',
      tags: ['多云管理'],
      refer: false,
    },
    {
      sortId: 69,
      id: 'KHzXcO01',
      title: '企业应如何防止 Kubernetes 的复杂性阻碍云发展进程？',
      category: '观点洞察',
      desc: '在以激烈竞争和不断升级的客户需求为特征的行业中，速度已成为关键的差异化因素。凭借支持应用程序快速开发和部署的能力，云计算已成为实现这一速度的圣杯——简单的按需容量，可随业务扩展，这些全部都采用运营成本模型。',
      author: '云联壹云',
      date: '2023-05-01',
      tags: ['Kubernetes'],
      refer: false,
    },
    {
      sortId: 68,
      id: 'me1JS9rD',
      title: '为什么越来越多的企业选择云数据存储而放弃本地数据存储？',
      category: '观点洞察',
      desc: '随着企业的发展，它们会产生大量数据。企业已经意识到，利用他们的数据做出数据驱动的决策对于创新和保持竞争优势至关重要。',
      author: '云联壹云',
      date: '2023-05-01',
      tags: ['多云管理','私有云','混合云','FinOps'],
      refer: false,
    },
    {
      sortId: 67,
      id: 'rgwMvQYU',
      title: '企业应如何减少云配置错误？',
      category: '观点洞察',
      desc: '在当今技术驱动的环境中，大多数公司都会在云上拥有一些工作负载。与本地网络不同，这些云环境缺乏安全的外部边界和特定的关闭时间。',
      author: '云联壹云',
      date: '2023-05-01',
      tags: ['混合云','多云管理','FinOps'],
      refer: false,
    },
    {
      sortId: 66,
      id: 'ABGDBOAS',
      title: '云下阴影：云计算中的影子IT会产生怎样的影响？',
      category: '观点洞察',
      desc: '未被批准的影子IT之所以会出现，是因为企业内部的集中化技术能力要么太慢，要么太过时，要么太受限制，而人员或项目正试图绕过这些限制，找到更好的解决方案。虽然这带来了立竿见影的好处，但也可能给企业带来风险和挑战。影子IT的使用会引起两极分化的情绪，这取决于你想要实现什么样的目的。',
      author: '云联壹云',
      date: '2023-05-01',
      tags: ['混合云','多云管理','FinOps'],
      refer: false,
    },
    {
      sortId: 65,
      id: '9p5UfeQ5',
      title: '2022年的云革命：云转移、云模型和云未来',
      category: '观点洞察',
      desc: '云计算是推动经济增长最强大的引擎之一，在疫情期间维持了世界经济的增长和供应链的运行。云计算使数以百万计的员工能够远程访问他们的数据和文件，从而极大地改变了业务结构，从而使数千家企业能够顺利、迅速地将其业务转移到外部。',
      author: '云联壹云',
      date: '2023-05-01',
      tags: ['混合云','多云管理','FinOps'],
      refer: false,
    },
    {
      sortId: 64,
      id: 'CeHGALv1',
      title: '企业的多云战略应该如何开始？',
      category: '观点洞察',
      desc: '根据HashiCorp的云状态报告，现在已经有超过 76% 的用户在使用多云，两年后这一比例将达到 86%。此外，其他调查也获得了类似的调查结果，并且在其多云战略中共享安全性是IT领导者的首要任务。',
      author: '云联壹云',
      date: '2023-05-01',
      tags: ['混合云','多云管理','FinOps'],
      refer: false,
    },
    {
      sortId: 63,
      id: 'VK0C1Ka2',
      title: '云效率的 3 个方面：成本、性能和速度',
      category: '观点洞察',
      desc: '在考虑实现云效率时，通常与围绕成本的讨论有关。然而，成本只是众多组成部分的其中之一。本文将更好地定义云效率及其三个组成部分——成本、性能和速度，并为实现云效率的所有方面提供建议。',
      author: '云联壹云',
      date: '2023-05-01',
      tags: ['混合云','多云管理','FinOps'],
      refer: false,
    },
    {
      sortId: 62,
      id: 'gou67rtY',
      title: '大数据和云：在云中实施大数据的详情分析',
      category: '观点洞察',
      desc: '已经有越来越多的大企业使用大数据和云。中小型企业也逐渐开始参与进来，但很少有人知道如何实施。本文将探讨大数据和云的相关信息以及如何使用它们。',
      author: '云联壹云',
      date: '2023-05-01',
      tags: ['混合云','多云管理'],
      refer: false,
    },
    {
      sortId: 61,
      id: 'k4QmZ0cP',
      title: '企业采用云计算失败的 7 大原因',
      category: '观点洞察',
      desc: '不是每个云计算采用的尝试都是成功的，会有许多原因导致云采用失败。',
      author: '云联壹云',
      date: '2023-05-01',
      tags: ['混合云','多云管理'],
      refer: false,
    },
    {
      sortId: 60,
      id: 'ufY3bLX5',
      title: '云变更管理：如何让变更为企业服务',
      category: '观点洞察',
      desc: '成功的企业管理与变革密切相关。后者使企业能够保持弹性并跟上不断变化的客户和内部需求。但是，如果这些更改管理不善，它们可能会导致项目延误、预算超支、生产力下降、客户不满意和其他灾难性事故。云环境中的变更管理可以帮助企业应对瞬息万变的环境，并开辟一条增加成功概率的道路。',
      author: '云联壹云',
      date: '2023-05-01',
      tags: ['混合云','多云管理'],
      refer: false,
    },
    {
      sortId: 59,
      id: 'J5iwwpIW',
      title: '企业云网络安全解决方案的10条评估标准',
      category: '最佳实践',
      desc: '随着企业扩展其云采用和关键业务用例，其云基础架构的安全性通常变得更加复杂。出于这个原因，专家会建议企业采用统一的多层方法来保护其云部署并确保稳健的云安全态势。',
      author: '云联壹云',
      date: '2023-05-01',
      tags: ['安全'],
      refer: false,
    },
    {
      sortId: 58,
      id: 'WhVtMIWy',
      title: '混合云——企业的最佳解决方案？',
      category: '观点洞察',
      desc: '一般来说，IT和通信服务可以通过三种方式部署在非常高的层次上：在本地、云端或两者的混合（混合）。云计算的业务优势是不可否认的；然而，有时采用完整的基于云的解决方案是不切实际的。',
      author: '云联壹云',
      date: '2023-05-01',
      tags: ['混合云','多云管理'],
      refer: false,
    },
    {
      sortId: 57,
      id: 'tMdQKedw',
      title: '云平台的云计算安全参数详解',
      category: '技术干货',
      desc: '云计算目前是 IT 行业中非常火热的概念和方向。目前，大型科技巨头正在为各个行业提供云服务，因为保护架构和企业数据是他们的基本政策。',
      author: '云联壹云',
      date: '2023-05-01',
      tags: ['安全'],
      refer: false,
    },
    {
      sortId: 56,
      id: 'R3xHVV2J',
      title: '多云准备好成为 DevOps 的基石了吗？',
      category: '观点洞察',
      desc: '从应用程序到其运行的基础设施， IT 现实都是分布式和异构的。企业正在探索如何在不影响可靠性、安全性或性能的情况下跨数据中心、公共云和边缘的任意组合交付应用程序。',
      author: '云联壹云',
      date: '2023-05-01',
      tags: ['混合云','多云管理'],
      refer: false,
    },
    {
      sortId: 55,
      id: 'weKYkJW8',
      title: '新品发布 | Cloudpods 3.8.7 版本上线！',
      category: '产品动态',
      desc: '2月24日，Cloudpods 新版本 v3.8.7 正式发布。本次更新主要以功能优化和问题修复为主。其中，我们对Cloudpods私有云的热迁移、克隆等高可用特性进行了优化，改进了迁移和克隆数据同步过程的进度展示，改进虚拟机热迁移过程中发生异常失败后的目标虚拟机的清理机制，如目标虚拟机异常退出，用户取消热迁移等异常场景。',
      author: '云联壹云',
      date: '2023-05-01',
      tags: ['企业版','Cloudpods','新版本发布'],
      refer: false,
    },
    {
      sortId: 54,
      id: 'ewquvVw8',
      title: '云计算与本地的灾难恢复有何不同？',
      category: '观点洞察',
      desc: '由于网络攻击、自然灾害和疫情的破坏，灾难恢复计划 (DRP) 受到越来越多的关注。完善的 DRP 可以减轻这些风险，但云计算的 DRP 与传统的本地资产的 DRP 有所不同。',
      author: '云联壹云',
      date: '2023-05-01',
      tags: ['备份与恢复'],
      refer: false,
    },
    {
      sortId: 53,
      id: '0C3Nyrc9',
      title: '多云是否有意义？企业应该如何抉择？',
      category: '观点洞察',
      desc: '多云的定义，即是使用多个云提供商。这是过去几年出现的一种模式，本文将分析它的意义及企业应如何抉择。',
      author: '云联壹云',
      date: '2023-05-01',
      tags: ['混合云','多云管理'],
      refer: false,
    },
    {
      sortId: 52,
      id: 'epEy5ILH',
      title: '云联壹云—云数据管理将会打破存储孤岛和团队孤岛',
      category: '观点洞察',
      desc: '云现在已经证明是企业的最佳选择之一，企业有信心将关键工作负载迁移到云。这将我们带到了非结构化数据的云数据管理主题，以及客户如何通过战略性地将云资源混合到他们的运营中来进行创新。',
      author: '云联壹云',
      date: '2023-05-01',
      tags: ['混合云','多云管理'],
      refer: false,
    },
    {
      sortId: 51,
      id: 'LjLYACQ2',
      title: '详解混合云安全性与合规性，降低风险的指导原则',
      category: '观点洞察',
      desc: '混合云安全已经经过一段时间的发展。云计算带来了各种维度，这些维度需要一种方法来扩展当前的政策、实践和技能。必须采取以企业为中心的视图，以实现集中可见性、保护控制和控制风险。',
      author: '云联壹云',
      date: '2023-05-01',
      tags: ['安全'],
      refer: false,
    },
    {
      sortId: 50,
      id: 'wIg8HiJk',
      title: 'ARM架构是云计算的未来吗？',
      category: '观点洞察',
      desc: '中央处理器 (CPU) 可以与人脑进行比较，因为其独特的架构允许它们以不同的方式求解数学方程。现在，x86是云计算中使用的主要架构。然而，值得注意的是，这种架构并非对所有场景都有效，其专有性质正在导致行业转向 Arm。',
      author: '云联壹云',
      date: '2023-05-01',
      tags: ['ARM'],
      refer: false,
    },
    {
      sortId: 49,
      id: 'F8NicPah',
      title: '企业控制云支出的云成本优化策略',
      category: '最佳实践',
      desc: '云计算因其高效的可扩展性和只为使用的内容付费的灵活性而备受企业青睐。团队可以利用 IT 向分散计算的转变来开发更好的产品，同时保持竞争力和敏捷性。',
      author: '云联壹云',
      date: '2023-05-01',
      tags: ['FinOps','多云管理'],
      refer: false,
    },
    {
      sortId: 48,
      id: '9b4YFXpI',
      title: '企业如何完成云计算最佳成本优化？',
      category: '观点洞察',
      desc: '云的可扩展性对企业的运营和发展而言具有两面性，可谓福祸相依。过度配置和云蔓延是真实存在的。其造成的成本浪费甚至会使科技巨头财务管理者都感到惊讶。',
      author: '云联壹云',
      date: '2023-05-01',
      tags: ['FinOps','多云管理'],
      refer: false,
    },
    {
      sortId: 47,
      id: 'dI2cUyI3',
      title: '企业的云服务选择：SaaS、PaaS、IaaS对比分析',
      category: '观点洞察',
      desc: '一般而言，企业有三种云计算服务模式可以选择。软件即服务（SaaS），这是一个完整的软件应用程序，具有用户界面；平台即服务（PaaS），开发人员可以在其中部署自己的应用程序的平台；基础设施即服务（IaaS），提供机器、存储和网络资源，开发人员可以通过安装自己的操作系统、应用程序和支持资源来管理。',
      author: '云联壹云',
      date: '2023-05-01',
      tags: ['混合云','多云管理'],
      refer: false,
    },
    {
      sortId: 46,
      id: 'Ueped5L8',
      title: '企业需要了解的10个云安全最佳实践',
      category: '最佳实践',
      desc: 'IT 安全社区因其共享信息和解决方案的特性而备受认可。如果企业正在迁移到云端，或者倾向于提高应用程序的安全性，可以很好地利用这一点。',
      author: '云联壹云',
      date: '2023-05-01',
      tags: ['安全'],
      refer: false,
    },
    {
      sortId: 45,
      id: 'zi8GmHfI',
      title: '企业如何成功完成云迁移？',
      category: '观点洞察',
      desc: '云应用市场从 2013 年的 300 亿美元增长到 2021 年的近1400 亿美元，预计到 2024 年将增长到 1660 亿美元。这些数据表明，越来越多的企业正在迁移到云端。',
      author: '云联壹云',
      date: '2023-05-01',
      tags: ['混合云','多云管理'],
      refer: false,
    },
    {
      sortId: 44,
      id: 'rLxHUTBj',
      title: '多云虚拟机统一监控功能详解',
      category: '技术干货',
      desc: '本文主要通过总体介绍、核心监控Agent介绍、总结和演示三个部分为大家解析多云虚拟机统一监控的功能。',
      author: '云联壹云',
      date: '2023-05-01',
      tags: ['混合云','多云管理'],
      refer: false, 
    },
    {
      sortId: 43,
      id: 'f7XhTblu',
      title: 'Cloudpods Golang实践',
      category: '技术干货',
      desc: 'Cloudpods是完全自研的一套云平台，Golang是该平台的主要后端开发语言。本文介绍我们在平台开发迭代过程中关于Golang的经验以及在Golang上积累的框架和库，包括积累的Golang工具库，以及基于这些工具库实现的开发框架。',
      author: '云联壹云',
      date: '2023-05-01',
      tags: ['Golang'],
      refer: false,
    },
    {
      sortId: 42,
      id: 'toMyEE34',
      title: '这两个原因，使Kubernetes变得如此复杂',
      category: '观点洞察',
      desc: 'Anthropic在Kubernetes内运行我们的大部分系统，因此我对该工具积累了更多的经验，对其也更加熟悉。虽然在它真的很棒，但我也确实经历了（大家会普遍经历的）其复杂性和调试的超高难度。',
      author: '云联壹云',
      date: '2023-05-01',
      tags: ['Kubernetes'],
      refer: false,
    },
    {
      sortId: 41,
      id: 'Q34lqqLY',
      title: '企业应如何在云系统上构建安全性？',
      category: '观点洞察',
      desc: '随着安全威胁的不断演变，网络安全成为了当今的热门话题，本文将讨论云安全团队的结构和角色，以及云安全的 5 个关键特性。',
      author: '云联壹云',
      date: '2023-05-01',
      tags: ['安全'],
      refer: false,
    },
    {
      sortId: 40,
      id: 'zPDmKHvl',
      title: 'ISP 是否可以更好地为边缘提供云计算？',
      category: '观点洞察',
      desc: '边缘计算最近越来越受到关注——因为在需要的位置附近拥有计算能力和数据存储是有优势的。随着边缘计算需求的增长，用户可能会认真考虑AWS、Azure和谷歌等公共云提供商是否是他们的最佳选择，或者他们的本地 ISP 是否最适合这项工作。',
      author: '云联壹云',
      date: '2023-05-01',
      tags: ['混合云','多云管理'],
      refer: false,
    },
    {
      sortId: 39,
      id: 'k4US1BdH',
      title: '云联壹云—超详细的ARM架构适配介绍！',
      category: '技术干货',
      desc: '本文主要介绍云联壹云平台如何适配ARM，并运行在ARM CPU架构的机器上。',
      author: '云联壹云',
      date: '2023-05-01',
      tags: ['ARM','私有云'],
      refer: false,
    },
    {
      sortId: 38,
      id: '0Ezmtsr6',
      title: '多云的定义之——数据可移植性',
      category: '观点洞察',
      desc: '世界正在走向多云。“多云”这个词的含义不能以单一的方式进行理解，而应该通过多方面的讨论来了解哪些类型的多云功能值得追求。',
      author: '云联壹云',
      date: '2023-05-01',
      tags: ['混合云','多云管理'],
      refer: false,
    },
    {
      sortId: 37,
      id: 'DatTkuBt',
      title: '云联壹云：多云的定义之——工作流可移植性',
      category: '观点洞察',
      desc: '为了帮助大家更加详细地了解哪些类型的多云功能值得追求，本文继续从工作流可移植性的视角研究多云。',
      author: '云联壹云',
      date: '2023-05-01',
      tags: ['混合云','多云管理'],
      refer: false,
    },
    {
      sortId: 36,
      id: '2pTVpxMl',
      title: '多云的定义之——工作负载可移植性',
      category: '观点洞察',
      desc: '作为多云定义系列的第三篇，本文将继续从工作负载可移植性的角度进行解析。',
      author: '云联壹云',
      date: '2023-05-01',
      tags: ['混合云','多云管理'],
      refer: false,
    },
    {
      sortId: 35,
      id: 'QhoJ758j',
      title: '云联壹云：多云的定义之——流量可移植性',
      category: '观点洞察',
      desc: '作为多云定义系列的第三篇，本文将继续从工作负载可移植性的角度进行解析。',
      author: '云联壹云',
      date: '2023-05-01',
      tags: ['混合云','多云管理'],
      refer: false,
    },
    {
      sortId: 34,
      id: 'pT9KH8fm',
      title: '企业面临的 5 大混合云安全挑战',
      category: '观点洞察',
      desc: '对于越来越多的企业而言，IT 环境包含公共云服务、私有云和本地基础设施的混合体，而后者在混合体中所占的比例越来越小。',
      author: '云联壹云',
      date: '2023-05-01',
      tags: ['混合云','安全'],
      refer: false,
    },
    {
      sortId: 33,
      id: 'xdSzkhhk',
      title: '2022 年的云未来： DevOps、开源和多云',
      category: '观点洞察',
      desc: '受到全球疫情影响，全球数字化转型加速。对于希望在防疫常态化的情况下保持发展的公司而言，持续的数字化转型不仅是一种趋势，更是一种业务需求。',
      author: '云联壹云',
      date: '2023-05-01',
      tags: ['混合云','多云管理','开源'],
      refer: false,
    },
    {
      sortId: 32,
      id: '30uSGMaa',
      title: '企业是否应该采用多云战略？',
      category: '观点洞察',
      desc: '在过去的几年里，云的采用一直在加速，许多企业用云托管的基础设施取代了传统的数据中心，并对应用程序进行更新以便利用基于云的服务。',
      author: '云联壹云',
      date: '2023-05-01',
      tags: ['混合云','多云管理'],
      refer: false,
    },
    {
      sortId: 31,
      id: 'snkPVgja',
      title: '云联壹云：新兴边缘云和基础计算设施详解',
      category: '观点洞察',
      desc: '如今，全球 Web 服务主要由公共云提供服务。当它们到达云边缘时，会被移交给电信有线和移动无线接入网络，以交付给终端用户。',
      author: '云联壹云',
      date: '2023-05-01',
      tags: ['混合云','多云管理'],
      refer: false,
    },
    {
      sortId: 30,
      id: 'BNadh4Gq',
      title: '云联壹云新品发布 | Cloudpods 3.8.5 版本上线！',
      category: '产品动态',
      desc: '我们针对这段时间用户反馈的一系列问题进行了改进，例如部分用户反馈使用5.4内核有兼容性问题，我们把默认的内核切换回来原来的3.10内核，另外还包括对增加虚拟磁盘总是使用virtio-scsi接口等用户反馈问题的修复。',
      author: '云联壹云',
      date: '2023-05-01',
      tags: ['企业版','新版本发布','Cloudpods'],
      refer: false,
    },
    {
      sortId: 29,
      id: 'olxSHS2g',
      title: '云联壹云：随着公司迁移到云，云浪费是否不可避免？',
      category: '观点洞察',
      desc: '事实证明，云浪费是技术和业务决策者使用云计算的主要障碍。',
      author: '云联壹云',
      date: '2023-05-01',
      tags: ['FinOps'],
      refer: false,
    },
    {
      sortId: 28,
      id: 'GxB0fiMf',
      title: '云联壹云：天空计算——云计算的下一个时代？',
      category: '观点洞察',
      desc: '根据加州大学伯克利分校的两位杰出计算机科学教授Ion Stoica和 Scott Shenker 的说法，我们即将从云计算时代过渡到“天空计算”时代。',
      author: '云联壹云',
      date: '2023-05-01',
      tags: ['Kubernetes'],
      refer: false,
    },
    {
      sortId: 27,
      id: 'yp1vQPq5',
      title: '云联壹云：超全面的Golang实践经验分享！',
      category: '技术干货',
      desc: '云联壹云是完全自研的一套融合云平台，Golang是主要的开发语言，本文主要介绍介绍在迭代过程中关于Golang的经验以及在Golang上积累的框架和库。',
      author: '云联壹云',
      date: '2023-05-01',
      tags: ['Golang'],
      refer: false,
    },
    {
      sortId: 26,
      id: 'Oz9XgT7E',
      title: '云联壹云：企业采用云计算如何保持适当规模，顺利解决大小合适的问题？',
      category: '最佳实践',
      desc: '现在挑选出一个优质的云服务商并不困难，更大的挑战在于请求适量的资源，确保它足以处理可变负载，并且不会为未使用的资源支付过多的费用。这项操作比想象中更棘手。实际上，由于过程的复杂性，创建了一个专门的术语“正确调整大小”。',
      author: '云联壹云',
      date: '2023-05-01',
      tags: ['FinOps','混合云','多云管理'],
      refer: false,
    },
    {
      sortId: 25,
      id: 'ZsQJWWkz',
      title: '云联壹云：企业采用多云面临的挑战和解决方案',
      category: '最佳实践',
      desc: '在过去的十年中，基础设施领域发生了巨大变化，越来越多的企业将其工作负载分布在多个平台上，包括本地和云中。这导致管理工作负载的方式发生很大变化，随之而来的是复杂性和风险的增加。跨多个平台的工作负载分布有很多种，多云和混合云是最常见的。',
      author: '云联壹云',
      date: '2023-05-01',
      tags: ['混合云','多云管理'],
      refer: false,
    },
    {
      sortId: 24,
      id: 'OIscl2mR',
      title: '云消费模式转变：满足企业的个性化需求是成功混合云的核心',
      category: '观点洞察',
      desc: '在当今世界的云部署中，企业的现代数字分布式特性需要一系列基础设施选项，以允许每个客户利用混合云技术来更好地满足他们的独特需求，同时优化相关成本。',
      author: '云联壹云',
      date: '2023-05-01',
      tags: ['混合云','多云管理'],
      refer: false,
    },
    {
      sortId: 23,
      id: 'E9Zu8XEt',
      title: '常见的多云架构模式、部署和网络拓扑详解',
      category: '最佳实践',
      desc: '主要介绍常见的多云架构模式、部署和网络拓扑、不同模式的快速快照，这些模式分为分布式部署和冗余部署。',
      author: '云联壹云',
      date: '2023-05-01',
      tags: ['混合云','多云管理'],
      refer: false,
    },
    {
      sortId: 22,
      id: 'ESgtVnfw',
      title: '云用户的真实需求：从多云、混合云到集成',
      category: '观点洞察',
      desc: '在云用户中，对“混合云”和“多云”这两个术语评价的两极分化程度较为严重。从之前的情况来看，混合云的使用表明工作负载正在从私有数据中心转移到公共云。现在，它意味着本地应用程序与云中的服务之间的集成。',
      author: '云联壹云',
      date: '2023-05-01',
      tags: ['混合云','多云管理'],
      refer: false,
    },
    {
      sortId: 21,
      id: 'mS985e6b',
      title: '为什么混合云需要虚拟化？',
      category: '观点洞察',
      desc: '在当今世界，一切都在向云端转移。我们所说的云，是指科技巨头的数据中心——即 AWS、Azure、谷歌、Equinix、甲骨文等，更具体地说，云计算更加为人所知的一面是主要的公共云参与者，即所谓的“公共云”。虽然这些大型云服务提供商及其大部分云竞争对手的业务量和规模都在增长，但他们的客户依赖这些服务来支持自己的业务的方式发生了明显的转变。',
      author: '云联壹云',
      date: '2023-05-01',
      tags: ['混合云','多云管理'],
      refer: false,
    },
    {
      sortId: 20,
      id: 'i6gt8r7H',
      title: '云联壹云：企业如何更经济高效地使用云和迁移到云？',
      category: '观点洞察',
      desc: '如今企业上云已经成为不可逆的潮流，但是对于云运营，特别是如何更经济高效地使用云和迁移到云等方面仍有疑虑，以下将会对相关内容进行讨论。',
      author: '云联壹云',
      date: '2023-05-01',
      tags: ['FinOps','混合云','多云管理'],
      refer: false,
    },
    {
      sortId: 19,
      id: 'lwxlsSMF',
      title: '云联壹云：下一个云计算时代将如何发展？',
      category: '观点洞察',
      desc: '根据 IBM 报告显示，单一的云方法即将淘汰。Digital Bulletin通过多位专家的见解了解推动这一趋势出现的的主要原因以及技术人员应该如何规划云计算的未来。',
      author: '云联壹云',
      date: '2023-05-01',
      tags: ['混合云','多云管理'],
      refer: false,
    },
    {
      sortId: 18,
      id: '20230505',
      title: '云联壹云：效率提升—物理机管理使用场景和实践',
      category: '最佳实践',
      desc: '本文将分享物理机管理使用场景和实践，分别是物理机相关背景、平台物理机管理架构的介绍，并结合实际场景，进行装机实践，演示物理机功能。',
      author: '云联壹云',
      date: '2023-05-01',
      tags: ['私有云','物理机'],
      refer: false,
    },
    {
      sortId: 17,
      id: 'YRU3Yf6K',
      title: '云联壹云：安全无小事，关于云计算和网络安全的一切你一定要了解！',
      category: '观点洞察',
      desc: '疫情已经肆虐将近两年，期间很多人被迫在家工作。尽管对于那些可以远程完成工作的人来说是一个很好的选择，但它也可能带来一些安全挑战——尤其是使用基于云计算的应用程序。',
      author: '云联壹云',
      date: '2023-05-01',
      tags: ['安全'],
      refer: false,
    },
    {
      sortId: 16,
      id: 'TLCjhLn3',
      title: '云联壹云：边缘计算将如何改变云计算的未来？',
      category: '观点洞察',
      desc: '过去十年，云计算范式兴起，主要包括云中存储和网络管理集中化。智能手机、计算机、可穿戴设备等移动设备日益增长的趋势正在推动物联网发展，并革新移动应用程序。',
      author: '云联壹云',
      date: '2023-05-01',
      tags: ['私有云'],
      refer: false,
    },
    {
      sortId: 15,
      id: 'N9XLsE4e',
      title: '超强预测：云计算领域将如何重新洗牌？',
      category: '观点洞察',
      desc: '以下是对云供应商（AWS，Azure，GCP）的论断：云供应商将越来越关注软件栈中的最低层：通过API租赁其数据中心的算力。其他纯软件提供商将在其上构建所有东西，包括数据库、运行代码等等。',
      author: '云联壹云',
      date: '2023-05-01',
      tags: ['混合云','多云管理'],
      refer: false,
    },
    {
      sortId: 14,
      id: 'Sfj2vhtO',
      title: '企业多云场景下的管理方案：多云统一账号管理（Cloud SSO）',
      category: '最佳实践',
      desc: '本篇文章介绍云联壹云多云账号统一管理功能。本文分三部分，首先介绍为什么要设计多云统一账号管理这个功能。其次，介绍此功能的详细方案和工作原理，最后，介绍如何使用多云账号统一管理功能。',
      author: '云联壹云',
      date: '2023-05-01',
      tags: ['多云管理','企业版'],
      refer: false,
    },
    {
      sortId: 13,
      id: 's6D6RdEG',
      title: '开源软件公司HashiCorp 上市：市值超过150亿美元，企业多云化成为必然选择',
      category: '观点洞察',
      desc: '开源软件公司HashiCorp于北京时间2021年12月9日晚间正式以“HCP”为股票代码在纳斯达克挂牌上市。截至收盘，HashiCorp市值约为153亿美元，这也是迄今为止今年全球市值最高的开源IPO。',
      author: '云联壹云',
      date: '2023-05-01',
      tags: ['多云管理'],
      refer: false,
    },
    {
      sortId: 12,
      id: '9s4lJag4',
      title: 'QEMU+OCFS2: 使用OCFS2作为虚拟机磁盘文件的SAN存储文件系统',
      category: '最佳实践',
      desc: '本文介绍OCFS2共享集群文件系统，如何配置以及如何在线扩容。',
      author: '云联壹云',
      date: '2023-05-01',
      tags: ['开源','Cloudpods','私有云'],
      refer: false,
    },
    {
      sortId: 11,
      id: 'VHWbolzr',
      title: '新品发布 | Cloudpods 3.8.4 版本上线！',
      category: '产品动态',
      desc: '11月4日，Cloudpods新版本 v3.8.4正式发布。这次小版本更新主要增加了一些近期客户需求以及BUG修复。',
      author: '云联壹云',
      date: '2023-05-01',
      tags: ['企业版','Cloudpods','新版本发布'],
      refer: false,
    },
    {
      sortId: 10,
      id: 'CKr65tFe',
      title: 'Cloudpods + Rook + Ceph: 轻松实现云原生的超融合私有云',
      category: '最佳实践',
      desc: 'Cloudpods 服务以容器化的方式运行在 Kubernetes 集群之上，按照 部署文档/多节点安装 文档部署完 Cloudpods 之后，环境就有了一个完整的 Kubernetes 集群。',
      author: '云联壹云',
      date: '2023-05-01',
      tags: ['开源','Cloudpods','私有云'],
      refer: false,
    },
    {
      sortId: 9,
      id: 'y7ylz78S',
      title: '新品发布 | Cloudpods 3.8 版本上线！',
      category: '产品动态',
      desc: '10月12日， Cloudpods 3.8 版本正式上线！',
      author: '云联壹云',
      date: '2023-05-01',
      tags: ['企业版','Cloudpods','新版本发布'],
      refer: false,
    },
    {
      sortId: 8,
      id: 'tkS7P1Y6',
      title: '为了企业上云，超过20%的成本浪费不可避免？',
      category: '观点洞察',
      desc: '“企业上云”是指企业通过利用便捷的网络资源，实现管理、业务等方面的数字化转型，重构企业的核心竞争力，最大限度创造企业价值。',
      author: '云联壹云',
      date: '2023-05-01',
      tags: ['多云管理','FinOps'],
      refer: false,
    },
    {
      sortId: 7,
      id: '20230504',
      title: '新品发布 | Cloudpods 3.7.7 版本上线！',
      category: '产品动态',
      desc: '9月14日，Cloudpods新版本 v3.7.7正式发布。这次小版本更新主要增加了一些近期客户需求以及BUG修复。',
      author: '云联壹云',
      date: '2023-05-01',
      tags: ['企业版','Cloudpods','新版本发布'],
      refer: false,
    },
    {
      sortId: 6,
      id: '20230503',
      title: '使用 Cgroups 限制 Kubernetes Pod 进程数',
      category: '技术干货',
      desc: 'Kubernetes 里面的 Pod 资源是最小的计算单元，抽象了一组（一个或多个）容器。容器也是 Linux 系统上的进程，但基于 Namespace 和 Cgroups(Control groups) 等技术实现了不同程度的隔离。 简单来说 Namespace 可以让每个进程有独立的 PID, IPC 和网络空间。Cgroups 可以控制进程的资源占用，比如 CPU ，内存和允许的最大进程数等等。',
      author: '李泽玺',
      date: '2023-05-01',
      tags: ['私有云','Kubernetes'],
      refer: false,
    },
    {
      sortId: 3,
      id: '20220719',
      title: '云联壹云入选爱分析报告',
      category: '公司动态',
      desc: '2022年6月24日，云联壹云入选国内领先的数字化市场研究与咨询机构爱分析发布的“2022爱分析 · IT运维厂商全景报告”。',
      author: '云联壹云',
      date: '2023-05-01',
      tags: ['融合云','多云管理','私有云'],
      refer: false,
    },
  ],
}



// WEBPACK FOOTER //
// ./src/article/config.js